import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

import {
  defaultStyles,
  sizes,
  variants,
} from '../../../components/CallToAction/styles/CallToAction.styled';

export const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .hs-form-html {
    .hsfc-Step__Content {
      display: flex;
      flex-direction: column;
      gap: ${spacing[6]};
      padding: ${spacing[0]} !important;
    }
    .hsfc-NavigationRow {
      margin: ${spacing[0]} !important;
      .hsfc-NavigationRow__Alerts {
        margin: ${spacing[0]} !important;
      }
    }
    .hsfc-Row {
      margin: ${spacing[0]} !important;
    }
    .hsfc-TextInput {
      display: flex;
      align-items: center;
      gap: ${spacing[8]};
      padding: ${spacing[10]} ${spacing[14]};
      border-radius: ${spacing[8]};
      border: 1px solid ${color.darkBlue[200]};
      background: ${color.common.white};
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      ${font('text', 'md', '400')}
      color: ${color.darkBlue[600]};
    }

    .hsfc-Button {
      ${defaultStyles}
      ${sizes.md}
      ${variants['Filled - Dark']}
      &:not([disabled]):hover {
        color: ${color.common.white};
        background: ${color.darkBlue[700]};
        border: 1px solid ${color.darkBlue[700]};
      }
      width: 100%;
    }
  }

  .disclaimer {
    padding-top: ${spacing[8]};
    ${font('text', 'xs', '400')}
    color: ${color.darkBlue[600]};
  }
`;

export const Success = styled.p`
  ${font('text', 'md', '700')}
  color: ${color.mediumGrey[600]};
`;
